import React, {Component} from 'react';


class Footer extends Component {

    render() {

        // console.debug("render MenuBar");
        return (
            <div>

                <footer>
                    <div className="showmainnav navpanel-btn" id="sloc">
                        <div id="arr">-&gt; | &lt;-</div>
                    </div>
                    <img src={require("../img/nav/Made-in-Germany.svg").default} alt="Made in Germany"/>
                </footer>

            </div>
        );
    }
}

export default Footer;
